import { useState, useEffect } from 'react';
import { fetchData, savePicks } from './services/api';
import Game from './components/Picks/Game';
import WeekButtons from './components/WeekButtons/WeekButtons';

const Picks = () => {
    const [data, setData] = useState([]);
    const [week, setWeek] = useState(1);
    const [loading, setLoading] = useState(true);
    const [selectedTeamIds, setSelectedTeamIds] = useState({});
    const [picks, setPicks] = useState([]);
    const [savedPicks, setSavedPicks] = useState({});

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            const result = await fetchData(week);
            setData(result);
            setLoading(false);
        };
        getData();
    }, [week]);

    const handleWeekClick = async (week) => {
        setWeek(week);
    };

    const handleTeamClick = (pick, matchupId, val, date) => {
        if ((date < new Date() || !(val > 0)) && false) {
            return null;
        }
        else {
            setSelectedTeamIds((prevSelectedTeamIds) => {
                return {
                    ...prevSelectedTeamIds,
                    [matchupId]: { "pick": pick, "val": val },
                };
            });

            setPicks((prevPicks) => {
                const newPicks = { ...prevPicks };

                if (newPicks[matchupId] && newPicks[matchupId].pick !== pick) {
                    setSavedPicks((prevSavedPicks) => {
                        const updatedSavedPicks = { ...prevSavedPicks };
                        delete updatedSavedPicks[matchupId];
                        return updatedSavedPicks;
                    });
                }
                newPicks[matchupId] = { "pick": pick, "val": val };
                return newPicks;
            });
        }
    };

    const handleSaveClick = async () => {
        const profile = JSON.parse(localStorage.getItem('profile'));
        const user = profile.Email;
        try {
            await savePicks(picks, user, week);
            setSavedPicks(picks);
        } catch (error) {
            console.error('Error saving picks:', error);
        }
    };

    if (loading) {
        return (
            <>
                <WeekButtons status={loading} handleWeekClick={handleWeekClick} />
                <div className="loader"></div>
            </>
            
        );
    }
    return (
        <>
            <WeekButtons status={loading} handleWeekClick={handleWeekClick} />
            <div className="page">
                {data.events && data.events.length > 0 ? (
                    data.events.map((item, index) => <Game key={index} game={item} click={handleTeamClick} picks={picks} />)
                ) : (
                    <p>No Games this week</p>
                )}

                <div className="save-section">
                    <div className="save-subsection">

                        <button id="mainsave" onClick={handleSaveClick}>
                            {Object.keys(picks).length == data.events.length ? "Submit Picks" :"Save Progress"}
                        </button>
                    </div>
                    <div className="save-subsection">
                        <div className="pickProgress">
                            <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 20 20">
                                <circle r="5" cx="10" cy="10" stroke="#666" strokeWidth="5" />
                                <circle r="5" cx="10" cy="10" stroke="#aaa" strokeWidth="5" strokeDasharray={`calc(${100 * Object.keys(picks).length / data.events.length} * 31.42 / 100) 31.42`} transform="rotate(-90) translate(-20)" />
                                <circle r="5" cx="10" cy="10" stroke="white" strokeWidth="5" strokeDasharray={`calc(${100 * Object.keys(savedPicks).length / data.events.length} * 31.42 / 100) 31.42`} transform="rotate(-90) translate(-20)" />

                                <circle r="5" cx="10" cy="10" strokeWidth="2" fill={Object.keys(savedPicks).length == data.events.length ? "white" : "black"} />
                                <line x1="7" y1="10.5" x2="9.25" y2="12.75" strokeWidth="1" />
                                <line x1="9" y1="12.5" x2="13" y2="8.5" strokeWidth="1" />
                            </svg>
                            {Math.min(Object.keys(savedPicks).length, 16)}/{Math.min(data.events.length, 16)} Saved
                        </div>

                    </div>
                    </div>
            </div>
        </>
        
    );
};

export default Picks;
